<script setup>

</script>

<template>
    <footer
        style=" position: relative; z-index: -1; margin-top: 16px;"
    >
        <b-card>
            <b-row>
                <b-col col sm="6">
                    2024 - {{ new Date().getFullYear() }} © InMotion.
                </b-col>
                <b-col col sm="6">
                    <div class="text-sm-end d-none d-sm-block">
                         Design & Develop with ❤️ by me. 
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </footer>
</template>